<template>
  <div>
    <div>
        <vs-button type="line" class="m-2" v-if="userRoot" @click="menu = 0;" color="#298AC6">Gestión de Bodega</vs-button>
        <vs-button line-origin="left"                      @click="menu = 1;" class="m-2" color="success" type="line">Revisión de códigos</vs-button>
        <vs-button  color="danger"         v-if="userRoot" @click="menu = 2;" type="line">Eliminar códigos</vs-button>
        <!--<vs-button line-position="top" line-origin="left" color="warning" type="line">Warning</vs-button>
        <vs-button line-position="top" line-origin="right" color="dark" type="line">Dark</vs-button>
        <vs-button disabled type="line">Disabled</vs-button> -->
    </div>
    <!--components-->
    <div>
        <div><ImportGestionBodegaVue    v-if="menu == 0"/></div>
        <div><ImportRevisionCodigosVue  v-if="menu == 1"/></div>
        <div><ImportEliminarCodigosVue  v-if="menu == 2"/></div>
    </div>
  </div>
</template>

<script>
const ImportGestionBodegaVue    = () => import('./GestionBodega/ImportGestionBodega.vue');
const ImportRevisionCodigosVue  = () => import('./RevisionCodigos/ImportRevisionCodigos.vue');
const ImportEliminarCodigosVue  = () => import('./EliminarCodigos/ImportEliminarCodigos.vue');
export default {
  components:{
    ImportGestionBodegaVue,
    ImportRevisionCodigosVue,
    ImportEliminarCodigosVue,
  },
  props:{
    userRoot:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      menu:1,
    };
  },
  mounted(){
    let me = this;
    if(me.userRoot){
      me.menu = 0;
    }
  },
};
</script>

<style scoped>
h1 {
  color: blue;
}
</style>
